export const PRODUCT_TYPE_OPTIONS = ["Organic", "Conventional", "Eco-Friendly"];
export const PRODUCT_SIZE_OPTIONS = ["1 kg", "5 kg", "10 kg", "25 kg"];
